/*
 * 환불·취소 목록 표(tabletV 이상)의 열 너비. 머리글과 행이 같은 값을 써야 줄이 맞는다.
 * tabletV(1180px)에서는 본문이 790px 남짓이라 좁게 잡고, desktopL(1440px)부터 넓힌다.
 */
export const REFUND_COLUMN_CLASS = {
  date: 'flex-shrink-0 w-[90px] desktopL:w-[120px]',
  number: 'flex-shrink-0 w-[100px] desktopL:w-[120px]',
  reason: 'flex-1 min-w-[120px]',
  user: 'flex-shrink-0 w-[100px] desktopL:w-[160px] min-w-0',
  amount: 'flex-shrink-0 w-[90px] desktopL:w-[100px]',
  status: 'flex-shrink-0 w-[110px] desktopL:w-[150px]',
  icon: 'flex-shrink-0 w-11 desktopL:w-[60px] px-0.5',
};
